import createHistory from 'history/createBrowserHistory';
import {routerMiddleware} from 'react-router-redux';
import {applyMiddleware, createStore} from 'redux';
import thunk from 'redux-thunk';

import reducers from './reducers';

export const history = createHistory();

const router = routerMiddleware(history),
    middlewares = applyMiddleware(thunk, router);

export const store = createStore(reducers, middlewares);

export default store;



// WEBPACK FOOTER //
// ./src/store.js